<p>
    {{label}}:
    <span class="text-primary">{{value}}</span>
</p>
